"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConsultant = exports.consultantContext = exports.ConsultantProvider = void 0;
var _auth = require("@ori/auth");
var _axios = require("@ori/axios");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _utils = require("../utils");
var _configurationContext = require("./configurationContext");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- needs to be refactored with whole OOB

const consultantContext = exports.consultantContext = /*#__PURE__*/(0, _react.createContext)({
  loadingVipAccess: true
});
const {
  Provider
} = consultantContext;
const ConsultantProvider = ({
  children
}) => {
  const {
    consultantNumber,
    consultantType
  } = (0, _configurationContext.useAppConfig)();
  const {
    customerId,
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    data
  } = (0, _globalApiClientReact.useGetApplicationsNavigationCustomerInfo)(customerId.toString(), undefined, {
    swr: {
      ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
      enabled: isUserVerified && !isAnonymousUser
    }
  });
  const {
    data: vipAccess,
    error
  } = (0, _fetching.useSWR)(_utils.vipOrderUrls.access, async () => _axios.axios.get(_utils.vipOrderUrls.access, {
    baseURL: window.location.origin
  }).then(response => response.data), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const loadingVipAccess = vipAccess === undefined && error === undefined;
  const value = (0, _react.useMemo)(() => ({
    consultantNumber: data?.consultantNumber?.toString() ?? consultantNumber,
    consultantType,
    isOrderOnBehalfVisible: !!(vipAccess?.VipAccessData?.ConsultantName && vipAccess.VipAccessData.ConsultantNumber > 0),
    loadingVipAccess,
    vipAccess
  }), [consultantNumber, consultantType, data?.consultantNumber, loadingVipAccess, vipAccess]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.ConsultantProvider = ConsultantProvider;
const useConsultant = () => (0, _react.useContext)(consultantContext);
exports.useConsultant = useConsultant;